<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-dumbbell</v-icon>
              Treinos
            </h1>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <empty-alert :icon="'dumbbell'" :color="'orange accent-4'" v-if="!trainings.length">
      <div slot="content">
        <p>
          <strong>Você ainda não tem treinos cadastrados</strong>
          <br>
          Se tiver alguma dúvida,
          <router-link :to="{name: 'UserSupport'}">entre em contato</router-link>
          com o professor.
        </p>
      </div>
    </empty-alert>

    <v-expansion-panel>
      <div class="section-box section-box-list" v-for="(training, index) in trainings" :key="index">
        <v-expansion-panel-content expand-icon="fal fa-angle-down">
          <div slot="header">
            {{ training.name }}
          </div>
          <section class="mx-4">
            <training-item :training="training"></training-item>
          </section>
        </v-expansion-panel-content>
      </div>
    </v-expansion-panel>
    <user-show-exercise></user-show-exercise>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import EmptyAlert from '@/modules/EmptyAlert'
// import router from '@/router'
import UserShowExercise from '@/components/user/exercises/UserShowExercise.vue'
import AdminUserShowTrainingItem from '@/components/admin/userShow/AdminUserShowTrainingItem'
const currentUser = JSON.parse(localStorage.getItem('currentUser'))

export default {
  data: () => ({
    search: '',
    trainings: []
  }),

  methods: {
    loadTrainings () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      axios.get(`${API.userTrainings}/?user=${currentUser._id}`).then(response => {
        this.trainings = response.data.trainings
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar os treinos', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    }
  },

  created () {
    this.loadTrainings()
    EventBus.$on('loadTrainings', this.loadTrainings)
  },

  components: {
    'empty-alert': EmptyAlert,
    'training-item': AdminUserShowTrainingItem,
    UserShowExercise
  }
}
</script>

<style scoped>
.v-expansion-panel {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserTrainings.vue